import { render, staticRenderFns } from "./CustomerMainInformation.vue?vue&type=template&id=f26840ca&"
import script from "./CustomerMainInformation.vue?vue&type=script&lang=js&"
export * from "./CustomerMainInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports